import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { cookieData } from '../funciones/ConsultaUser';

import { requerido, numero, selectRequerido, requeridoFecha, limpiaCamposRepre, email } from './Validaciones'

export const consultaUser = (respuesta) => {
        let leerCookie = (nombre) => {
        let lista = document.cookie.split(";");
        let micookie;
        let igual;
        let valor;
        for (let i in lista) {
          let busca = lista[i].search(nombre);
          if (busca > -1) {micookie=lista[i]}
        }
        
        if (micookie === undefined) return null;
        
        igual = micookie.indexOf("=");
        valor = micookie.substring(igual + 1);
        return valor;
      }

    let valor = leerCookie("S_ID")
    let valor2 = leerCookie("U_ID");

    /* let valor = "";
    let valor2 = "";
    let lista = document.cookie.split(";");
    for (let i = 0; i <= lista.length; i++){
        if (lista[i] !== undefined) {
            let item = lista[i].split("=");
            if (item[0] === " S_ID"){
                valor = item[1];
            }else if (item[0] === " U_ID"){
              valor2 = item[1];
            }
        }
    } */

    let Content = {
        sId: valor,
        uId: valor2,
    }

    Post(`${Url}userName`, Content, (resp) => {
        let data = JSON.parse(resp);
        respuesta(data.user_001);
    });
}

export const consultaGeneral = (respuesta) => {

    let { paices, paicesDir, paicesRepre} = "";

    consultaPaices ((resp) => {
        paices= resp
        paicesDir= resp
        paicesRepre= resp
    })


    let entidades = (entidad1, entidad2, campo, respuesta) => {
        let entidades= [];
        let entidadesSelect= "";
        for (let i in entidad1){
            if (entidad1[i].id === entidad2){
                entidadesSelect = { value: entidad1[i].id, label:entidad1[i][campo], status: "" }
            }
            if(entidad1[i][campo] !== "Default"){
                entidades.push(
                    { value: entidad1[i].id, label: entidad1[i][campo], status: "" }
                )
            }
        }

        respuesta({entidades, entidadesSelect})
    }

    
    consultaUser((usuario) => {
        let Content = {
            usuario: usuario
        }
        let dataState = []
        Post(`${Url}dataUser`, Content, (resp) => {

            let data = JSON.parse(resp);
            let sexo = { value: 'M', label: 'Masculino' }
            if(data.sexo === "F") sexo = { value: 'F', label: 'Femenino' }

            let edad = 0;
            
            calculaEdad (new Date(data.fecha), (resp) => {
                edad = resp[0].edad
            })

            let {notificacionClass, notificacionIcon, notificacionText, notificacionText2, notificacionStyles, estados, estadosSelect, ciudades, ciudadesSelect, municipios, municipiosSelect, parroquias, parroquiasSelect,
                estadosDir, selectEstadoDir, ciudadesDir, ciudadesSelectDir, municipiosDir, municipiosSelectDir, parroquiasDir,
                parroquiasSelectDir, estadosRepre, selectEstadoRepre, ciudadesRepre, ciudadesSelectRepre, municipiosRepre,
                municipiosSelectRepre, parroquiasRepre, parroquiasSelectRepre } = "";

            /* STATUS DEL USUARIO */
            if(data.statusU === "1"){
                notificacionClass = "custom-alert-info"
                notificacionIcon = "fa fa-info-circle"
                notificacionText = "Completa los datos para continuar",
                /* notificacionText2 = "Este paso es solo para estudiantes REGULARES, si eres aspirante a un cupo ingresa primero a la sección ADMISIÓN", */
                notificacionText2 = "Completa los campos para actualizar tus datos del Perfil con Información Verificable",
                notificacionStyles = { fontSize:15, position:"absolute", top: 1 }
            }else if(data.statusU === "2"){
                notificacionClass = "custom-alert-danger"
                notificacionIcon = "fa fa-exclamation-triangle"
                notificacionText = "Tus datos no están validados, debes eperar que sean verificados para poder utilizar el sistema. Espera un Email de notificación"
                notificacionStyles = { fontSize:15, position:"absolute", top: 6 }
            }else if(data.statusU === "3"){
                notificacionClass = "custom-alert-success"
                notificacionIcon = "fa fa-check"
                notificacionText = "Datos Verificados. Tu cuenta está validada"
                notificacionStyles = { fontSize:15, position:"absolute", top: 2 }
            }else if(data.statusU === "4"){
                notificacionClass = "custom-alert-danger"
                notificacionIcon = "fa fa-exclamation-circle"
                notificacionText = "Datos No Aprobados. Tu cuenta no está validada debido a que no fue aprobada. Por favor revisa la información"
                notificacionStyles = { fontSize:15, position:"absolute", top: 2 }
            }else if(data.statusU === "5"){
                notificacionClass = "custom-alert-warning"
                notificacionIcon = "fa fa-exclamation-triangle"
                notificacionText = "Ya hiciste el proceso de admisión. Por favor imprime la planilla y lleva los recaudos a administración"
                notificacionStyles = { fontSize:15, position:"absolute", top: 2 }
            }

            /* DATOS PERSONALES */
            entidades (data.estados, data.estado_select, "estado_name", (resp) => {
                estados = resp.entidades;
                estadosSelect = resp.entidadesSelect;
                if(estadosSelect.value === 1) estadosSelect = {
                    value: '', label: ' - Selecciona un Estado - ', status: "" }
            })

            entidades (data.ciudades, data.ciudades_select, "ciudad_name", (resp) => {
                ciudades = resp.entidades;
                ciudadesSelect = resp.entidadesSelect;
                if(ciudadesSelect.value === 1) ciudadesSelect = {
                    value: '', label: ' - Selecciona una Ciudad - ', status: "" }
            })

            entidades (data.municipios, data.municipios_select, "municipio_name", (resp) => {
                municipios = resp.entidades;
                municipiosSelect = resp.entidadesSelect;
                if(municipiosSelect.value === 1) municipiosSelect = {
                    value: '', label: ' - Selecciona un Municipio - ', status: "" }
            })

            entidades (data.parroquias, data.parroquias_select, "parroquia_name", (resp) => {
                parroquias = resp.entidades;
                parroquiasSelect = resp.entidadesSelect;
                if(parroquiasSelect.value === 1) parroquiasSelect = {
                    value: '', label: ' - Selecciona una Parroquia - ', status: "" }
            })

            /* DIRECCION */
            entidades (data.estados_dir, data.estado_select_dir, "estado_name", (resp) => {
                estadosDir = resp.entidades;
                selectEstadoDir = resp.entidadesSelect;
                if(selectEstadoDir.value === 1) selectEstadoDir = {
                    value: '', label: ' - Selecciona un Estado - ', status: "" }
            })

            entidades (data.ciudades_dir, data.ciudades_select_dir, "ciudad_name", (resp) => {
                ciudadesDir = resp.entidades;
                ciudadesSelectDir = resp.entidadesSelect;
                if(ciudadesSelectDir.value === 1) ciudadesSelectDir = {
                    value: '', label: ' - Selecciona una Ciudad - ', status: "" }
            })

            entidades (data.municipios_dir, data.municipios_select_dir, "municipio_name", (resp) => {
                municipiosDir = resp.entidades;
                municipiosSelectDir = resp.entidadesSelect;
                if(municipiosSelectDir.value === 1) municipiosSelectDir = {
                    value: '', label: ' - Selecciona un Municipio - ', status: "" }
            })

            entidades (data.parroquias_dir, data.parroquias_select_dir, "parroquia_name", (resp) => {
                parroquiasDir = resp.entidades;
                parroquiasSelectDir = resp.entidadesSelect;
                if(parroquiasSelectDir.value === 1) parroquiasSelectDir = {
                    value: '', label: ' - Selecciona una Parroquia - ', status: "" }
            })

            /* DIRECCION REPRESENTANTE */
            entidades (data.estados_repre, data.estado_select_repre, "estado_name", (resp) => {
                estadosRepre = resp.entidades;
                selectEstadoRepre = resp.entidadesSelect;
                if(selectEstadoRepre.value === 1) selectEstadoRepre = {
                    value: '', label: ' - Selecciona un Estado - ', status: "" }
            })

            entidades (data.ciudades_repre, data.ciudades_select_repre, "ciudad_name", (resp) => {
                ciudadesRepre = resp.entidades;
                ciudadesSelectRepre = resp.entidadesSelect;
                if(ciudadesSelectRepre.value === 1) ciudadesSelectRepre = {
                    value: '', label: ' - Selecciona una Ciudad - ', status: "" }
            })

            entidades (data.municipios_repre, data.municipios_select_repre, "municipio_name", (resp) => {
                municipiosRepre = resp.entidades;
                municipiosSelectRepre = resp.entidadesSelect;
                if(municipiosSelectRepre.value === 1) municipiosSelectRepre = {
                    value: '', label: ' - Selecciona un Municipio - ', status: "" }
            })

            entidades (data.parroquias_repre, data.parroquias_select_repre, "parroquia_name", (resp) => {
                parroquiasRepre = resp.entidades;
                parroquiasSelectRepre = resp.entidadesSelect;
                if(parroquiasSelectRepre.value === 1) parroquiasSelectRepre = {
                    value: '', label: ' - Selecciona una Parroquia - ', status: "" }
            })

            let carrera = { value: "", label: " - Selecciona una Carrera - " }
            if (data.carrera_valor !== "") {
                carrera = { value: data.carrera_valor, label: data.carrera_name  }
            }

            let fechaN = new Date();
            if (data.fecha !== null) fechaN = new Date(data.fecha)
            
            dataState = {
                valorSex: sexo,
                selectNac: { value: data.nac_value, label: data.nac_value },
                cedula: { text: data.cedula, status: "" },
                pasaporte: { text: data.pasaporte, status: "" },
                nombre1: { text: data.nombre1, status: "" },
                nombre2: { text: data.nombre2, status: "" },
                apellido1: { text: data.apellido1, status: "" },
                apellido2: { text: data.apellido2, status: "" },

                parroquias: parroquias,
                selectParroquia: parroquiasSelect,
                municipios: municipios,
                selectMunicipio: municipiosSelect,
                ciudades: ciudades,
                selectCiudad: ciudadesSelect,
                estados: estados,
                selectEstado: estadosSelect,
                selectPais: { value: data.pais_value, label: data.pais_label, status: "" },
                fecha: fechaN,
                fechaFormat: new Date(data.fecha),
                etnia: { text: data.etnia, status: "" },
                edad: edad,

                selectPaisDir: { value: data.pais_value_dir, label: data.pais_label_dir, status: "" },
                estadosDir: estadosDir,
                selectEstadoDir: selectEstadoDir,
                ciudadesDir: ciudadesDir,
                selectCiudadDir: ciudadesSelectDir,
                municipiosDir: municipiosDir,
                selectMunicipioDir: municipiosSelectDir,
                parroquiasDir: parroquiasDir,
                selectParroquiaDir: parroquiasSelectDir,
                calle: { text: data.calle_dir, status: "" },
                casa: { text: data.casa_dir, status: "" },
                tlf1: { text: data.tlf1, status: "" },
                tlf2: { text: data.tlf2, status: "" },
                tlf3: { text: data.tlf3, status: "" },

                selectNacr: { value: data.nac_value_repre, label: data.nac_value_repre },
                cedulaRepre: { text: data.cedula_repre, status: "" },
                pasaporteRepre: { text: data.pasaporte_repre, status: "" },
                nombre1Repre: { text: data.nombre1_repre, status: "" },
                nombre2Repre: { text: data.nombre2_repre, status: "" },
                apellido1Repre: { text: data.apellido1_repre, status: "" },
                apellido2Repre: { text: data.apellido2_repre, status: "" },

                selectPaisRepre: { value: data.pais_value_repre, label: data.pais_label_repre, status: "" },
                estadosRepre: estadosRepre,
                selectEstadoRepre: selectEstadoRepre,
                ciudadesRepre: ciudadesRepre,
                selectCiudadRepre: ciudadesSelectRepre,
                municipiosRepre: municipiosRepre,
                selectMunicipioRepre: municipiosSelectRepre,
                parroquiasRepre: parroquiasRepre,
                selectParroquiaRepre: parroquiasSelectRepre,
                calleRepre: { text: data.calle_repre, status: "" },
                casaRepre: { text: data.casa_repre, status: "" },

                emailRepre: { text: data.email_repre, status: "" },
                tlf1Repre: { text: data.tlf1_repre, status: "" },
                tlf2Repre: { text: data.tlf2_repre, status: "" },
                tlf3Repre: { text: data.tlf3_repre, status: "" },

                tituloVentana: "Mi Perfil",
                button: {
                    Icon:"fa fa-save",
                    Title:"Guardar",
                },
                notificacionClass: notificacionClass,
                notificacionIcon: notificacionIcon,
                notificacionText: notificacionText,
                notificacionText2: notificacionText2,
                notificacionStyles: notificacionStyles,

                paices: paices,
                paicesDir: paicesDir,
                paicesRepre: paicesRepre,

                valorCarrera: carrera
            }

            let user= usuario;

            respuesta([dataState, user, data.t_name, data.statusU])
        });
    })
}

export const consultMenciones = (respuesta) => {
    Post(`${Url}searchMenciones`, "", (resp) => {
        let data = JSON.parse(resp);
        let contenido= []

        for (let i in data[0]) {
            contenido.push(
                { value: data[0][i].id, label: data[0][i].nom_mencion, status: "" }
            )
        }
        respuesta(contenido)
    });
}

export const consultaPaices = (respuesta) => {
    Post(`${Url}searchPaices`, "", (resp) => {
        let data = JSON.parse(resp);
        let contenido= []

        for (let i in data) {
            contenido.push(
                { value: data[i].id, label: data[i].pais_name, status: "" }
            )
        }
        respuesta(contenido)
    });
}

export const consultaEstados = (id, respuesta) => {
    let Contenido = { paisId: id }
        
    Post(`${Url}searchEstados`, Contenido, (resp) => {
        let data = JSON.parse(resp);
        let contenido= []

        for (let i in data) {
            if(data[i].estado_name !== "Default"){
                contenido.push(
                    { value: data[i].id, label: data[i].estado_name, status: "" }
                )
            }
        }
        respuesta(contenido)
    });
}

export const consultaCiudMunic = (id, respuesta1, respuesta2) => {
    
    let Contenido = { estadoId: id }
        
    Post(`${Url}searchCiudades`, Contenido, (resp) => {
        let data = JSON.parse(resp);
        let contenido= []

        for (let i in data) {
            contenido.push(
                { value: data[i].id, label: data[i].ciudad_name, status: "" }
            )
        }
        respuesta1(contenido)
    });

    Post(`${Url}searchMunicipios`, Contenido, (resp) => {
        let data = JSON.parse(resp);
        let contenido= []

        for (let i in data) {
            contenido.push(
                { value: data[i].id, label: data[i].municipio_name, status: "" }
            )
        }
        respuesta2(contenido)
    });
}

export const consultaParroquia = (id, respuesta) => {
    let Contenido = { municipioId: id }
        
    Post(`${Url}searchParroquias`, Contenido, (resp) => {
        let data = JSON.parse(resp)
        let contenido= []

        for (let i in data) {
            contenido.push(
                { value: data[i].id, label: data[i].parroquia_name, status: "" }
            )
        }
        respuesta(contenido)
    });
}

export const calculaEdad = (fecha, respuesta) => {
    let newFecha = new Date(fecha)
    let dia = newFecha.getDate()
    let mes = (newFecha.getMonth() + 1)
    let year = newFecha.getFullYear()

    let fecha_hoy = new Date();
    let ahora_year = fecha_hoy.getYear();
    let ahora_mes = (fecha_hoy.getMonth()+1);
    let ahora_dia = fecha_hoy.getDate();

    let edad = (ahora_year + 1900) - year;
    
    if ( ahora_mes < mes ) edad--;
    if ((mes === ahora_mes) && (ahora_dia < dia)) edad--;
    if (edad > 1900) edad -= 1900;

    let meses=0;

    if(ahora_mes > mes) meses = ahora_mes - mes;
    if(ahora_mes < mes) meses = 12-(mes - ahora_mes);
    if(ahora_mes === mes && dia > ahora_dia) meses = 11;

    let dias=0;

    if(ahora_dia > dia) dias = ahora_dia-dia;
    if(ahora_dia < dia) {
        let ultimoDiaMes = new Date(ahora_year, ahora_mes, 0);
        dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
    }

    let fullEdad = {
        edad: edad,
        fechaTit: { text: `${edad} años ${meses} meses y ${dias} dias`, status: "text-info" },
    }

    respuesta([fullEdad])
    
}

export const UpdPerfil = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores para continuar"
    }];

    requerido(errores, campos.pass1, "", "", "", "El campo Contraseña Actual es obligatorio", (resp) => {
        errores = resp[1];
        nameErr.push(resp[2])
    });

    requerido(errores, campos.pass2, "", "", "", "El campo Nueva Contraseña es obligatorio", (resp) => {
        errores = resp[1];
        nameErr.push(resp[2])
    });

    requerido(errores, campos.pass3, "", "", "", "El campo Repite la Contraseña es obligatorio", (resp) => {
        errores = resp[1];
        nameErr.push(resp[2])
    });

    if (campos.pass2 !== campos.pass3) {
        errores ++;
        nameErr.push("Las contraseñas no coinciden");
    }

    if (errores === 0) {
        let leerCookie = (nombre) => {
            let lista = document.cookie.split(";");
            let micookie;
            let igual;
            let valor;
            for (let i in lista) {
              let busca = lista[i].search(nombre);
              if (busca > -1) {micookie=lista[i]}
            }
            
            if (micookie === undefined) return null;
            
            igual = micookie.indexOf("=");
            valor = micookie.substring(igual + 1);
            return valor;
        }
    
        let valor2 = leerCookie("U_ID");
        /* let valor2 = "";
        let lista = document.cookie.split(";");
        for (let i = 0; i <= lista.length; i++){
            if (lista[i] !== undefined) {
                let item = lista[i].split("=");
                if (item[0] === " U_ID"){
                  valor2 = item[1];
                }
            }
        } */
    
        let Content = {
            uId: valor2,
            pass: campos.pass3,
            pass2: campos.pass2,
            cPass: campos.pass1
        }
    
        Post(`${Url}updPass`, Content, (resp) => {
            let data = JSON.parse(resp);
            if(data.status === 0){
                errores ++;
                nameErr.push(data.message);
                mensaje = [{
                    status: "error",
                    mensaje: "No se pudo guardar la información. Revisa los errores para continuar"
                }];
            }else{
                mensaje = [{
                    status: "info",
                    mensaje: "Se ha actualizado tu clave de usuario Exitosamente"
                }];
            }

            respuesta([errores, nameErr, mensaje])
        });
    }else{
        respuesta([errores, nameErr, mensaje])
    }
}

export const guardar = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];
    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los campos en rojo para continuar"
    }];

    /* Validaciones de DATOS PERSONALES */
    requerido(errores, campos.cedula.text, "cedula", "ced", "Cédula de Identidad", "El campo Cédula es obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.cedula.text, "cedula", "ced", "El campo Cédula debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre1.text, "nombre1", "nombres", "Nombres", "El campo Primer Nombre es obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.apellido1.text, "apellido1", "apellidos", "Apellidos", "El campo Primer Apellido es obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    /*Validaciones de DATOS DE NACIMIENTO */
    selectRequerido(errores, campos.selectPais, "selectPais", " - Incompleto - ", "Debes seleccionar el País de Nacimiento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });
    requeridoFecha(errores, campos.fecha, "Debe seleccionar la Fecha de Nacimiento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    /*Validaciones de DATOS DE DIRECCION */
    selectRequerido(errores, campos.selectPaisDir, "selectPaisDir", " - Incompleto - ", "El campo País [Dirección de Habitación] es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.calle.text, "calle", "", "", "El campo Calle [Dirección de Habitación] es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.casa.text, "casa", "", "", "El campo Casa [Dirección de Habitación] es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });


    /* Validaciones de Teléfono */
    if (campos.tlf1.text !== "") numero(errores, campos.tlf1.text, "tlf1", "telefonos", "El campo Tlf. Habitación debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (campos.tlf2.text !== "") numero(errores, campos.tlf2.text, "tlf2", "telefonos", "El campo Tlf. Celular debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (campos.tlf3.text !== "") numero(errores, campos.tlf3.text, "tlf3", "telefonos", "El campo Tlf. Oficina debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });



    /* Validaciones de SOLO ESTUDIANTES */
    if (campos.tName === "EST"){
        selectRequerido(errores, campos.valorCarrera, "valorCarrera", " - Selecciona una Carrera - ", "Debes seleccionar la carrera", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });



        selectRequerido(errores, campos.selectEstado, "selectEstado", " - Incompleto - ", "Debes seleccionar el Estado de Nacimiento", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });
    
        /* selectRequerido(errores, campos.selectCiudad, "selectCiudad", " - Incompleto - ", "Debes seleccionar la Ciudad de Nacimiento", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        }); */
    
        selectRequerido(errores, campos.selectMunicipio, "selectMunicipio", " - Incompleto - ", "Debes seleccionar el Municipio de Nacimiento", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });
    
        selectRequerido(errores, campos.selectParroquia, "selectParroquia", " - Incompleto - ", "Debes seleccionar la Parroquia de Nacimiento", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });

        


        selectRequerido(errores, campos.selectEstadoDir, "selectEstadoDir", " - Incompleto - ", "El campo Estado [Dirección de Habitación] es Obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });
    
        /* selectRequerido(errores, campos.selectCiudadDir, "selectCiudadDir", " - Incompleto - ", "El campo Ciudad [Dirección de Habitación] es Obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        }); */
    
        selectRequerido(errores, campos.selectMunicipioDir, "selectMunicipioDir", " - Incompleto - ", "El campo Municipio [Dirección de Habitación] es Obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });
    
        selectRequerido(errores, campos.selectParroquiaDir, "selectParroquiaDir", " - Incompleto - ", "El campo Parroquia [Dirección de Habitación] es Obligatorio", (resp) => {
            errores = resp[1];
            states.push(resp[0][0])
            nameErr.push(resp[2])
        });





        /* Validaciones de REPRESENTANTE */
        if(campos.edad < 18) {
            requerido(errores, campos.cedulaRepre.text, "cedulaRepre", "cedRepre", "Cédula de Identidad", "El campo Cédula del Representante es obligatorio", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            });

            requerido(errores, campos.nombre1Repre.text, "nombre1Repre", "nombresRepre", "Nombres", "El campo Nombre del Representante es obligatorio", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            });

            requerido(errores, campos.apellido1Repre.text, "apellido1Repre", "apellidosRepre", "Apellidos", "El campo Apellido del Representante es obligatorio", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            });

            /*Validaciones de DATOS DE DIRECCION */
            selectRequerido(errores, campos.selectPaisRepre, "selectPaisRepre", " - Incompleto - ", "El campo País [Representante] es Obligatorio", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            });

            selectRequerido(errores, campos.selectEstadoRepre, "selectEstadoRepre", " - Incompleto - ", "El campo Estado [Representante] es Obligatorio", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            });

            /* selectRequerido(errores, campos.selectCiudadRepre, "selectCiudadRepre", " - Incompleto - ", "El campo Ciudad [Representante] es Obligatorio", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            }); */

            selectRequerido(errores, campos.selectMunicipioRepre, "selectMunicipioRepre", " - Incompleto - ", "El campo Municipio [Representante] es Obligatorio", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            });

            selectRequerido(errores, campos.selectParroquiaRepre, "selectParroquiaRepre", " - Incompleto - ", "El campo Parroquia [Representante] es Obligatorio", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            });

            requerido(errores, campos.calleRepre.text, "calleRepre", "", "", "El campo Calle [Representante] es Obligatorio", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            });
        
            requerido(errores, campos.casaRepre.text, "casaRepre", "", "", "El campo Casa [Representante] es Obligatorio", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            });

            if(campos.emailRepre.text !== "") email(errores, campos.emailRepre.text, "emailRepre", "", "", "El formato de Email [Representante] es incorrecto", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            });

            /* Validaciones de Teléfono */
            if (campos.tlf1Repre.text !== "") numero(errores, campos.tlf1Repre.text, "tlf1Repre", "telefonosRepre", "El campo Tlf. Habitación [Representante] debe contener solo números", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            });

            if (campos.tlf2Repre.text !== "") numero(errores, campos.tlf2Repre.text, "tlf2Repre", "telefonosRepre", "El campo Tlf. Celular [Representante] debe contener solo números", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            });

            if (campos.tlf3Repre.text !== "") numero(errores, campos.tlf3Repre.text, "tlf3Repre", "telefonosRepre", "El campo Tlf. Oficina [Representante] debe contener solo números", (resp) => {
                errores = resp[1];
                states.push(resp[0][0])
                nameErr.push(resp[2])
            });

        }else{
            limpiaCamposRepre((resp) => { states.push(resp[0][0]) });
        }

    }
    
    if (errores === 0){
        consultaUser((usuario) => {
            /* Consultar si la ci o el password ya existen */
            let Content = {
                ci: campos.cedula.text,
                pasaporte: campos.pasaporte.text,
                usuario: usuario
            }

            Post(`${Url}consultDispCiPass`, Content, (resp) => {
                let data = JSON.parse(resp);
                if (data > 0) {
                    let mensaje = [{
                        status: "error",
                        mensaje: "No se pudo guardar la información. Revisa los campos en rojo para continuar"
                    }];
                    nameErr.push("La Cédula o el Pasaporte ya están registrados")
                    errores ++;
                    respuesta([states, mensaje, errores, nameErr])
                }else{
                    Post(`${Url}updateUserData`, campos, () => {
                    });
                    mensaje = [{
                        status: "info",
                        mensaje: ""
                    }];

                    respuesta([states, mensaje, errores, nameErr])
                }
            });
        })
        
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }

    /* states.push({
        button: {
            Icon:"fa fa-save",
            Title:"Guardar"
        }
    }) */
    
    
}

export const ConsultaDisp = (string, tipo, respuesta) => {
    consultaUser((usuario) => {
        let Content = {
            strings: string,
            usuario: usuario
        }
    
        if (tipo === "cedula"){
            Post(`${Url}consultDispCi`, Content, (resp) => {
                let data = JSON.parse(resp);
                respuesta(data);
            });
        }else if (tipo === "pasaporte"){
            Post(`${Url}consultDispPassport`, Content, (resp) => {
                let data = JSON.parse(resp);
                respuesta(data);
            });
        }
    })
    
}

export const guardarDir = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];
    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los campos en rojo para continuar"
    }];

    /* Validaciones de DATOS PERSONALES */

    requerido(errores, campos.cedula.text, "cedula", "ced", "Cédula de Identidad", "El campo Cédula es obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.cedula.text, "cedula", "ced", "El campo Cédula debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre1.text, "nombre1", "nombres", "Nombres", "El campo Primer Nombre es obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.apellido1.text, "apellido1", "apellidos", "Apellidos", "El campo Primer Apellido es obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });


    requeridoFecha(errores, campos.fecha, "Debe seleccionar la Fecha de Nacimiento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (campos.tlf1.text !== "") numero(errores, campos.tlf1.text, "tlf1", "telefonos", "El campo Tlf. Habitación debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (campos.tlf2.text !== "") numero(errores, campos.tlf2.text, "tlf2", "telefonos", "El campo Tlf. Celular debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });


    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                uId: cookie[1]
            }
            Post(`${Url}updateUserDataDir`, Content, () => { 
                mensaje = [{
                    status: "info",
                    mensaje: "Los datos del estudiante han sido actualizados"
                }];

                respuesta([states, mensaje, errores, nameErr])
            });
        });
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}


// WEBPACK FOOTER //
// ./src/funciones/PefilFunction.jsx